module.exports = __webpack_public_path__ + "img/2.0585fe65.jpg";